export default __webpack_public_path__ + "static/media/DowloadIcon.6959b35c.svg";